const EnumMetodoLiberacaoHierarquia = {
  NOVA_HIERARQUIA: 'Risco aplicado por hierarquia',
  RISCO_APLICADO_FUNCIONARIO: 'Risco aplicado por funcionário',
}
export default EnumMetodoLiberacaoHierarquia;